import { BACKEND_URL } from "@/lib/api";

const loaded = new Set();

export function loadFonts(families) {
  const todo = families.filter((f) => f && !loaded.has(f));
  if (!todo.length) return;
  todo.forEach((f) => loaded.add(f));
  const q = todo.map((f) => `family=${encodeURIComponent(f).replace(/%20/g, "+")}:wght@400;500;600;700`).join("&");
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = `${BACKEND_URL}/api/fonts/css?${q}&display=swap`;
  document.head.appendChild(link);
}

export const fullName = (i = {}) => [i.first_name, i.last_name].filter(Boolean).join(" ");
export const telHref = (n) => `tel:${String(n).replace(/[^\d+]/g, "")}`;
export const waHref = (n, msg) => {
  const digits = String(n).replace(/\D/g, "");
  return `https://wa.me/${digits}${msg ? `?text=${encodeURIComponent(msg)}` : ""}`;
};
export const mapsHref = (c) => c.maps_url || `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(c.address)}`;

export const BLOCK_LABELS = {
  contacts: "Contatti",
  socials: "Social",
  links: "Link e CTA",
  text: "Testo libero",
  image: "Immagine / banner",
  hours: "Orari",
  divider: "Separatore",
  button: "Pulsante",
  services: "Lista servizi",
  file: "Documento PDF",
  whatsapp: "Scrivi su WhatsApp",
};

export const BUILTIN = ["contacts", "socials", "links"];

export const newId = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random()}`);

export function newBlock(type) {
  const data = {
    text: { title: "Titolo", body: "" },
    image: { url: "", alt: "", caption: "", link: "" },
    hours: { title: "Orari di apertura", rows: [{ day: "Lun – Ven", hours: "9:00 – 18:00" }], note: "" },
    divider: { style: "line" },
    button: { label: "Richiedi informazioni", url: "", variant: "filled" },
    services: { title: "Servizi", items: [{ name: "", description: "", price: "" }] },
    file: { title: "", url: "", filename: "", label: "Scarica il listino prezzi", description: "PDF" },
    whatsapp: { title: "Scrivimi su WhatsApp", number: "", placeholder: "Ciao, vorrei informazioni su…", button_label: "Invia su WhatsApp" },
  }[type];
  return { id: newId(), type, visible: true, data: data || {} };
}

export const SOCIAL_FIELDS = [
  { key: "instagram", label: "Instagram", placeholder: "https://instagram.com/nomeutente" },
  { key: "facebook", label: "Facebook", placeholder: "https://facebook.com/pagina" },
  { key: "linkedin", label: "LinkedIn", placeholder: "https://linkedin.com/in/nome" },
  { key: "tiktok", label: "TikTok", placeholder: "https://tiktok.com/@nomeutente" },
  { key: "youtube", label: "YouTube", placeholder: "https://youtube.com/@canale" },
  { key: "pinterest", label: "Pinterest", placeholder: "https://pinterest.com/nomeutente" },
];

export function contrastRatio(a, b) {
  const lum = (hex) => {
    const c = hex.replace("#", "");
    const rgb = [0, 2, 4].map((i) => parseInt(c.substr(i, 2), 16) / 255).map((v) => (v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4));
    return 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];
  };
  const [l1, l2] = [lum(a), lum(b)];
  return { ratio: (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05), darkOnLight: l1 < l2 };
}
